<template>
    <Head title="My Courses" />
    <div class="px-4 md:px-8">
        <Courses />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import Courses from '@/components/courses/courses.vue';
</script>
